import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlDescription } from '@shared/models/profiles/ControlDescription';

// eyebrow
export const ExpressionLeftEyebrowRaised = 'left_eyebrow_raise';
export const ExpressionRightEyebrowRaised = 'right_eyebrow_raise';
export const ExpressionEyebrowsRaised = 'eyebrows_raised';
export const ExpressionLeftEyebrowLowered = 'left_eyebrow_lower';
export const ExpressionRightEyebrowLowered = 'right_eyebrow_lower';
export const ExpressionEyebrowsLowered = 'eyebrows_lower';

// mouth
export const ExpressionSmile = 'smile';
export const ExpressionStoppedSmile = 'stop_smile';
export const ExpressionMouthOpened = 'mouth_open';
export const ExpressionMouthClosed = 'mouth_close';
export const ExpressionMouthPucker = 'mouth_pucker';

// eyes
export const ExpressionLeftEyeClosed = 'left_eye_close';
export const ExpressionRightEyeClosed = 'right_eye_close';
export const ExpressionLeftEyeOpened = 'left_eye_open';
export const ExpressionRightEyeOpened = 'right_eye_open';
export const ExpressionEyesClosed = 'both_eyes_close';
export const ExpressionEyesOpened = 'both_eyes_open';

export const FaceControls = [
    ExpressionLeftEyebrowRaised,
    ExpressionRightEyebrowRaised,
    ExpressionEyebrowsRaised,
    ExpressionLeftEyebrowLowered,
    ExpressionRightEyebrowLowered,
    ExpressionEyebrowsLowered,
    ExpressionSmile,
    ExpressionStoppedSmile,
    ExpressionMouthOpened,
    ExpressionMouthClosed,
    ExpressionLeftEyeClosed,
    ExpressionRightEyeClosed,
    ExpressionLeftEyeOpened,
    ExpressionRightEyeOpened,
    ExpressionEyesClosed,
    ExpressionEyesOpened,
];

const createFaceCommand = (
    value: string,
    title: CommonResourceKey,
    description: CommonResourceKey
): IControlDescription => {
    return {
        value,
        title,
        description,
    };
};

export const FaceControlDescription = [
    createFaceCommand(
        ExpressionSmile,
        'common:expression.startSmiling.title',
        'common:expression.startSmiling.description'
    ),
    createFaceCommand(
        ExpressionStoppedSmile,
        'common:expression.stopSmiling.title',
        'common:expression.stopSmiling.description'
    ),
    createFaceCommand(
        ExpressionEyebrowsRaised,
        'common:expression.eyebrows.title',
        'common:expression.eyebrows.description'
    ),
    createFaceCommand(
        ExpressionMouthOpened,
        'common:expression.openMouth.title',
        'common:expression.openMouth.description'
    ),
    createFaceCommand(
        ExpressionMouthClosed,
        'common:expression.closeMouth.title',
        'common:expression.closeMouth.description'
    ),
];
